import type { ReactElement } from "react";
import { useState } from "react";

import { IconButton, Tooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import {
    StyledAddConditionContainer,
    StyledEmptyText,
} from "app/pages/sales-intelligence/common-components/filters-panel";
import type { ISiteTagsDto } from "app/pages/sales-intelligence/domain/leads/types/filter-values";
import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";

import type SiteTagsFilterModel from "../../../models/SiteTagsFilter/SiteTagsFilterModel";
import { SiteTagsModal } from "./modals/SiteTagsModal/SiteTagsModal";

const SiteTagsFilter = ({
    filter,
    value = [],
    onFilterUpdate,
}: IFilterViewBaseProps<SiteTagsFilterModel>): ReactElement => {
    const [isOpenModal, setIsOpenModal] = useState(false);

    const handleOpenModal = () => {
        setIsOpenModal(true);
    };

    const renderAddButton = () => {
        const button = (
            <IconButton
                type="flat"
                iconName="add"
                onClick={handleOpenModal}
                dataAutomation="site-tags-filter-button-add"
            >
                {translate("si.lead_gen_filters.filters.siteTags.button.add")}
            </IconButton>
        );

        if (value.length > 0) {
            return (
                <Tooltip content={translate("si.lead_gen_filters.filters.siteTags.button.add.tooltip")}>
                    {button}
                </Tooltip>
            );
        }

        return button;
    };

    const handleClose = () => {
        setIsOpenModal(false);
    };

    const handleApply = (item: ISiteTagsDto) => {
        onFilterUpdate([...value, item]);
        setIsOpenModal(false);
    };

    return (
        <>
            <SiteTagsModal
                isOpen={isOpenModal}
                selected={null}
                value={value}
                isExcludeAvailable={filter.isExcludeInclusionAvailable(value, null)}
                onClose={handleClose}
                onCancel={handleClose}
                onApply={handleApply}
            />

            <StyledEmptyText isHidden={value.length > 0}>
                {translate("si.lead_gen_filters.filters.siteTags.empty_text")}
            </StyledEmptyText>
            <StyledAddConditionContainer>{renderAddButton()}</StyledAddConditionContainer>
        </>
    );
};

export default SiteTagsFilter;
